/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleRentalHistoryItem } from './VehicleRentalHistoryItem';
import {
    VehicleRentalHistoryItemFromJSON,
    VehicleRentalHistoryItemFromJSONTyped,
    VehicleRentalHistoryItemToJSON,
    VehicleRentalHistoryItemToJSONTyped,
} from './VehicleRentalHistoryItem';

/**
 * 
 * @export
 * @interface VehicleRentalHistoryResponse
 */
export interface VehicleRentalHistoryResponse {
    /**
     * 
     * @type {Array<VehicleRentalHistoryItem>}
     * @memberof VehicleRentalHistoryResponse
     */
    items?: Array<VehicleRentalHistoryItem>;
}

/**
 * Check if a given object implements the VehicleRentalHistoryResponse interface.
 */
export function instanceOfVehicleRentalHistoryResponse(value: object): value is VehicleRentalHistoryResponse {
    return true;
}

export function VehicleRentalHistoryResponseFromJSON(json: any): VehicleRentalHistoryResponse {
    return VehicleRentalHistoryResponseFromJSONTyped(json, false);
}

export function VehicleRentalHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(VehicleRentalHistoryItemFromJSON)),
    };
}

export function VehicleRentalHistoryResponseToJSON(json: any): VehicleRentalHistoryResponse {
    return VehicleRentalHistoryResponseToJSONTyped(json, false);
}

export function VehicleRentalHistoryResponseToJSONTyped(value?: VehicleRentalHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(VehicleRentalHistoryItemToJSON)),
    };
}

